// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

export default {
	state: {
		//manOfTheMatches: [] as HasuraManOfTheMatche[],
		manOfTheMatches: [] as any[],
	},

	// ================ Getters ================
	getters: {
		manOfTheMatches(state: any) {
			return state.manOfTheMatches;
		},
	},

	// ================ Mutations ================
	mutations: {
		setManOfTheMatches(state: any, manOfTheMatches: any) {
			state.manOfTheMatches = manOfTheMatches;
		},
	},

	// ================= Actions =================
	actions: {
		async insertManOfTheMatch({ commit }: any, manOfTheMatch: any) {
			console.time('insertManOfTheMatch');

			const response = await apolloClient
				.mutate({
					mutation: gql`
						mutation insert_multiple_man_of_the_matches($objects: [man_of_the_matches_insert_input!]!) {
							insert_man_of_the_matches(objects: $objects) {
								returning {
									id
								}
							}
						}
					`,
					variables: {
						objects: [manOfTheMatch],
					},
				})
				.catch(err => {
					console.debug(err);
					throw new Error('Man of the match Creation Failed');
				});

			console.timeEnd('insertManOfTheMatch');

			return (response as any).data.insert_man_of_the_matches.returning[0].id;
		},

		async insertLeagueManOfTheMatchJoin({ state, commit }: any, joins: any) {
			console.log('insertLeagueManOfTheMatchJoin');

			const response: any = await apolloClient
				.mutate({
					mutation: gql`
						mutation InsertLeagueManOfTheMatchJoin($objects: [join_man_of_the_matches_leagues_insert_input!]!) {
							insert_join_man_of_the_matches_leagues(objects: $objects) {
								affected_rows
							}
						}
					`,
					// Parameters
					variables: {
						objects: joins,
					},
				})
				.catch(err => {
					console.error('insertLeagueManOfTheMatchJoin');
					console.debug(err);
				});

			return response.data;
		},

		async getManOfTheMatches({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query getManOfTheMatches {
						man_of_the_matches {
							id
							name
							created_at
							updated_at
							city {
								id
								name
							}
							country {
								id
								name
							}
							join_league_manofthematch {
								id
								league
								leagueByLeague {
									id
									league_type
									display_name
									season
									kick_off_date
									locationObj: locationByLocation {
										id
										name
										city {
											id
											name
											country {
												id
												name
											}
										}
									}
									player_type
									team_size
									day_of_week
									placeholdersInLeague: placeholderTeamsByParentLeague {
										name
										carry_points
										id
										parent_finals
										parent_group
										parent_league
										seeding_group
										seeding_league
										seeding_match
										seeding_position
										type
									}
									league_teams {
										team {
											id
											name
											placeholder
											type
										}
									}
									status
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { man_of_the_matches } = response.data;
			commit('setManOfTheMatches', man_of_the_matches);

			return;
		},

		async updateManOfTheMatch({ commit, state }: any, manOfTheMatch: any) {
			console.log('updating man of the match...');
			const response = await apolloClient.query({
				query: gql`
					mutation update_man_of_the_matches($id: uuid!, $object: man_of_the_matches_set_input!) {
						update_man_of_the_matches(where: { id: { _eq: $id } }, _set: $object) {
							returning {
								id
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					id: manOfTheMatch.id,
					object: manOfTheMatch,
				},
			});

			const { update_man_of_the_matches } = response.data;

			return update_man_of_the_matches[0];
		},

		async getManOfTheMatchById({ commit, state }: any, { manOfTheMatchId }: any) {
			let _manOfTheMatchId = manOfTheMatchId;

			const response = await apolloClient.query({
				query: gql`
					query getManOfTheMatchById($_manOfTheMatchId: uuid!) {
						man_of_the_matches(where: { id: { _eq: $_manOfTheMatchId } }) {
							id
							name
							created_at
							updated_at
							city {
								id
								name
							}
							country {
								id
								name
							}
							join_league_manofthematch {
								id
								league
								leagueByLeague {
									id
									league_type
									display_name
									season
									kick_off_date
									locationObj: locationByLocation {
										id
										name
										city {
											id
											name
											country {
												id
												name
											}
										}
									}
									player_type
									team_size
									day_of_week
									placeholdersInLeague: placeholderTeamsByParentLeague {
										name
										carry_points
										id
										parent_finals
										parent_group
										parent_league
										seeding_group
										seeding_league
										seeding_match
										seeding_position
										type
									}
									league_teams {
										team {
											id
											name
											placeholder
											type
										}
									}
									parentLeagues: joinLeaguesMiniLeaguesByMiniLeague {
										league: leagueByLeague {
											id
											display_name
										}
									}
									status
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					_manOfTheMatchId,
				},
			});

			const { man_of_the_matches } = response.data;

			return man_of_the_matches[0];
		},
	},
};
